__turbopack_context__.v({
  "active": "FanaticalPopover-module__Eb7DmG__active",
  "darkBackground": "FanaticalPopover-module__Eb7DmG__darkBackground",
  "dot": "FanaticalPopover-module__Eb7DmG__dot",
  "dots": "FanaticalPopover-module__Eb7DmG__dots",
  "popover": "FanaticalPopover-module__Eb7DmG__popover",
  "title": "FanaticalPopover-module__Eb7DmG__title",
  "tooltipBox": "FanaticalPopover-module__Eb7DmG__tooltipBox",
});
